import React from 'react';

import {SaveAction} from 'registry/field/FieldTable';

import SchemaInterfaceFieldTable, {
  BaseSchemaInterfaceFieldTableProps,
  ClientInterfaceField,
} from './SchemaInterfaceFieldTable';

export interface SchemaInterfaceEditFieldTableProps extends BaseSchemaInterfaceFieldTableProps {
  onFieldUpdate: (updatedField: ClientInterfaceField) => void;
  onFieldAdd: (addedField: ClientInterfaceField) => void;
  onFieldRemove: (apiId: string) => void;
  submissionWarnings: Array<JSX.Element>;
}

export function SchemaInterfaceEditFieldTable(props: SchemaInterfaceEditFieldTableProps): JSX.Element {
  const handleFieldSave = (field: ClientInterfaceField, action: SaveAction): void => {
    if (action === SaveAction.CHANGE) {
      if (field.apiId) {
        props.onFieldUpdate(field);
      } else {
        props.onFieldAdd(field);
      }
    } else if (action === SaveAction.REMOVE) {
      if (field.apiId) {
        props.onFieldRemove(field.apiId);
      }
    }
  };

  return <SchemaInterfaceFieldTable {...props} onFieldSave={handleFieldSave} isBeingCreated={false} />;
}

export default SchemaInterfaceEditFieldTable;
